import { render, staticRenderFns } from "./Lookup.vue?vue&type=template&id=83b9a998&scoped=true"
import script from "./Lookup.vue?vue&type=script&lang=js"
export * from "./Lookup.vue?vue&type=script&lang=js"
import style0 from "./Lookup.vue?vue&type=style&index=0&id=83b9a998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b9a998",
  null
  
)

export default component.exports